module.exports = __webpack_public_path__ + "img/resume1_active.27c34434.png";